import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { ErrorData, errorResult } from '@synergy/api';
import { FormikErrors } from 'formik';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { ProductPrice } from './../models/product-price';
import { ProductPriceFormValues } from '../models/form-values/product-price-form-values';
import { SupplierSpecialOffer } from '../models/supplier-special-offer';
import { productDetailPricesRequestSelector } from './product-detail-prices-selectors';

export const PRODUCT_DETAIL_PRICES_ERROR = 'PRODUCT_DETAIL_PRICES_ERROR';
export const PRODUCT_DETAIL_PRICES_FETCH = 'PRODUCT_DETAIL_PRICES_FETCH';
export const PRODUCT_DETAIL_PRICES_RECEIVE = 'PRODUCT_DETAIL_PRICES_RECEIVE';
export const PRODUCT_DETAIL_PRICES_UPDATE = 'PRODUCT_DETAIL_PRICES_UPDATE';
export const PRODUCT_DETAIL_PRICES_SAVE = 'PRODUCT_DETAIL_PRICES_SAVE';
export const PRODUCT_DETAIL_PRICES_SUPPLIER_SPECIAL_OFFERS_FETCH =
    'PRODUCT_DETAIL_PRICES_SUPPLIER_SPECIAL_OFFERS_FETCH';
export const PRODUCT_DETAIL_PRICES_SUPPLIER_SPECIAL_OFFERS_RECEIVE =
    'PRODUCT_DETAIL_PRICES_SUPPLIER_SPECIAL_OFFERS_RECEIVE';

const error = (errorData?: ErrorData) => ({
    type: PRODUCT_DETAIL_PRICES_ERROR,
    errorData,
});

const receivePrices = (prices: ProductPrice) => {
    return {
        type: PRODUCT_DETAIL_PRICES_RECEIVE,
        prices,
    };
};

const receiveSupplierOffers = (offers: SupplierSpecialOffer[]) => {
    return {
        type: PRODUCT_DETAIL_PRICES_SUPPLIER_SPECIAL_OFFERS_RECEIVE,
        offers,
    };
};

export const updateProductPrices = (
    formData: ProductPriceFormValues,
    isDirty: boolean,
    isValid: boolean,
    errors: FormikErrors<ProductPriceFormValues>
) => {
    return {
        type: PRODUCT_DETAIL_PRICES_UPDATE,
        formData,
        isDirty,
        isValid,
        errors,
    };
};

export const saveProductDetailPrices = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PRODUCT_DETAIL_PRICES_SAVE });
        const request = productDetailPricesRequestSelector(getState());
        if (!request) {
            return errorResult();
        }

        const productId = getState().product.detail.prices.productDetailPrice?.id;
        if (!productId) {
            return errorResult();
        }

        const response = await api.product.detail.prices.patchPrices(productId, request);
        if (response.success) {
            dispatch(receivePrices(response.result));
        } else {
            dispatch(error(response.error));
        }
        return response;
    };
};

export const fetchProductPrices = (id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PRODUCT_DETAIL_PRICES_FETCH });

        const response = await api.product.detail.prices.getPrices(id);
        if (response.success) {
            dispatch(receivePrices(response.result));
        } else {
            dispatch(error(response.error));
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchSupplierOffers = (id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PRODUCT_DETAIL_PRICES_SUPPLIER_SPECIAL_OFFERS_FETCH });

        const response = await api.product.detail.prices.getSupplierSpecialOffers(id);
        if (response.success) {
            dispatch(receiveSupplierOffers(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
